module.exports = __webpack_public_path__ + "icono_save.png?1a8dd966401f7785138dcced880dde48";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono_save.png
// module id = 643
// module chunks = 0 2 7 8 9 10 43 44